// PurchaseOrderAddItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class PurchaseOrderAddItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false
    }
  }

  static get propTypes () {
    return {
      onIntroAdd: PropTypes.func,
      onClose: PropTypes.func,
      onAddTermsAndCondition: PropTypes.func,
      onAddDiscountPhase: PropTypes.func
    }
  }

  componentDidMount () {
    window.rootApp.addEventListener('click', this._handleDocumentClick)
  }

  componentWillUnmount () {
    window.rootApp.removeEventListener('click', this._handleDocumentClick)
  }

  show () {
    this.setState({ active: true })
  }

  hide () {
    this.setState({ active: false })

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  _renderAction (title, icon, onClick) {
    if (!onClick) {
      return null
    }

    return (
      <div className='actionbtn'>
        <div className='actinfo'>
          <IntlMessage ident={title} />
        </div>
        <IconButton
          type='primary'
          size='big'
          icon={icon}
          className='purchaseadd'
          canHover={false}
          onClick={onClick}
        />
      </div>
    )
  }

  render () {
    const { onIntroAdd, onAddTermsAndCondition, onAddDiscountPhase } = this.props
    const className = classnames('purchaseorder-additem', {
      active: this.state.active
    })

    return (
      <div className={className}>
        {this._renderAction('estimate.view.titleAddDiscountPhase', 'purchaseorder-adddiscount', onAddDiscountPhase)}
        {this._renderAction('estimate.view.titleAddIntro', 'purchaseorder-addintro', onIntroAdd)}
        {this._renderAction('estimate.view.titleTermsandCondition', 'purchaseorder-terms', onAddTermsAndCondition)}
      </div>
    )
  }

  /* Event handlers */
  _handleDocumentClick = (_event) => {
    if (this.state.active) {
      this.hide()
    }
  };
}

export default PurchaseOrderAddItem
